import {
  Separator as ChakraSeparator,
  HStack,
  StackProps,
  Text,
} from '@chakra-ui/react';
import React from 'react';

type Props = StackProps & {
  label?: string;
};

const Separator = React.forwardRef<HTMLDivElement, Props>(
  ({ label, ...rest }, ref) =>
    label ? (
      <HStack ref={ref} my={4} {...rest}>
        <Separator borderColor="gray.300" flex="1" my={0} />
        <Text color="gray.600" flexShrink="0" px={2}>
          {label}
        </Text>
        <Separator borderColor="gray.300" flex="1" my={0} />
      </HStack>
    ) : (
      <ChakraSeparator ref={ref} borderColor="gray.300" my={4} {...rest} />
    )
);

export default Separator;
